import {Injectable} from '@angular/core';
import {Globals} from '../../../../../globals';
import {forkJoin} from "rxjs";
import {TranslateService} from "@ngx-translate/core";
import {HttpParams, HttpResponse} from "@angular/common/http";
import {AuthHttpService} from "../../../../../services/auth-http.service";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {DeleteDialogComponent} from "../../../../../shared/dialogs/delete-dialog/delete-dialog.component";
import {SortTableService} from "../../../services/sort-table.service";
import {DialogRoadLaneComponent} from '../../../dialogs/dialog-road-lane/dialog-road-lane.component';
import {CreateDialogComponent} from '../../../../../shared/dialogs/create-dialog/create-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class LaneTypesService {

  public laneTypes: any = [];
  public projList: any = [];
  public edit_allowed: Boolean;
  public no_access: any;
  public isDataAvailable: any;
  private privileges: any;
  private readonly changeLangCancel: any;
  private error_data: any;
  private created: any;
  private lane_type: any;
  private updated: any;
  private delete: any;
  private deleted: any;
  public allLaneCodes: any = [];
  public currentUserid: string;
  private no_permission: string;
  private file_size: any;
  private file_type: any;
  private file_width_heights: any;
  disableButton: boolean = false;
  private nameExisted: any;
  allLaneTypes: any = [];
  laneTypeSel: any;

  constructor(
    public Globals: Globals,
    public translate: TranslateService,
    private http: AuthHttpService,
    public dialog: MatDialog,
    public sortTableService: SortTableService,
  ) {
    //translate
    this.Globals.langJS.subscribe(() => {
      this.onLangChanged();
      this.translate.use(this.Globals.lang)
    });
  }

  onLangChanged() {
    this.translateLaneTypeName();
    forkJoin([
      this.translate.get('error_data'), // 0
      this.translate.get('created'), // 1
      this.translate.get('lane_type'), // 2
      this.translate.get('updated'), // 3
      this.translate.get('ad_ro_ma_Delete'),//4
      this.translate.get('deleted'),//5
      this.translate.get('no_rights'),//6
      this.translate.get('file_size'),//7
      this.translate.get('file_type'),//8
      this.translate.get('file_width_heights'),//9
      this.translate.get('name_or_code_existed'),//10
    ]).subscribe((res) => {
      this.error_data = res[0];
      this.created = res[1];
      this.lane_type = res[2];
      this.updated = res[3];
      this.delete = res[4];
      this.deleted = res[5];
      this.no_permission = res[6];
      this.file_size = res[7];
      this.file_type = res[8];
      this.file_width_heights = res[9];
      this.nameExisted = res[10];
    })
  }

  public async getLaneDataByDefault() {
    this.Globals.error = true;
    if (!!(this.Globals.user)) {
      this.no_access = false;
      this.edit_allowed = this.privileges;
      this.projList = !this.projList.length ? await this.getProjectList() : this.projList;
      this.laneTypes = await this.fetchLaneTypes();
      this.translateLaneTypeName();
      this.isDataAvailable = true
    }
  }

  /**
   *
   */
  getIconTitle() {
    return `${this.file_size}<br>${this.file_type} gif, png, jpg, jpeg, webp.<br>${this.file_width_heights} 25px.`;
  }

  /**
   * Fetch lane types
   * @protected
   */
  async fetchLaneTypes() {
    try {
      let res = await this.http.get('/api/lane-types/get-lane-types').toPromise();
      res.body.forEach(lane => {
        lane.lane_name = JSON.parse(lane.lane_name);
      })
      return res.body;
    } catch (e) {
      console.log(e)
    }
  }

  /**
   * Translate road lane type name.
   */
  translateLaneTypeName() {
    const lang = this.Globals.lang;
    if (this.laneTypes) {
      this.laneTypes.map(lane => {
        if (lang in lane.lane_name) {
          lane.name = lane.lane_name[lang];
        }
      })
    }
    // Sorting data by road name.
    this.laneTypes = this.sortTableService.sortDataByParameter(this.laneTypes, 'name');
  }

  /**
   * Fetch all projects in system.
   */
  async getProjectList() {
    try {
      const res = await this.http.get('/api/projects/get-all-projects').toPromise();
      this.isDataAvailable = true;
      return res.body;
    } catch (e) {
      console.log(e)
    }
  }

  /**
   * Create new road lane type.
   * @param laneParams
   */
  createLaneTypeRequest(laneParams: any) {
    this.sendDataAndCreateDialog(
      '/api/lane-types/create-lane-types',
      laneParams,
      `${this.lane_type} ${this.created.toLowerCase()}`,
    );
  }

  createCopyOfRoadTypeRequest(laneParams: any) {
    this.sendDataAndCreateDialog(
      '/api/lane-types/copy-lane-types',
      laneParams,
      `${this.lane_type} ${this.created.toLowerCase()}`,
    );
  }

  /**
   * Update selected road lane type.
   * @param updateParams
   */
  updateLaneTypeRequest(updateParams: any) {
    this.sendDataAndCreateDialog(
      '/api/lane-types/update-lane-types',
      updateParams,
      `${this.lane_type} ${this.updated.toLowerCase()}`,
    );
  }

  /**
   *
   * @param laneData
   * @param lane_type_delete_perm
   */
  deleteLaneTypeRequest(laneData: any, lane_type_delete_perm: any) {
    const dialogLaneRef = this.dialog.open(DeleteDialogComponent, <MatDialogConfig>{
      data: {
        lane_type_id: laneData.road_lane_types_id,
        text: `${this.delete} ${this.lane_type.toLowerCase()} "${laneData.name}"`,
        action: this.delete,
        subtext: lane_type_delete_perm
      }
    });
    dialogLaneRef.afterClosed().subscribe(result => {
      if (result == 'del') {
        const params = {
          'road_lane_types_id': laneData.road_lane_types_id,
        };
        this.sendDataAndCreateDialog(
          '/api/lane-types/delete-lane-type',
          params,
          `${this.lane_type} ${this.deleted.toLowerCase()}`,
        );
      }
    });
  }

  /**
   * Send data to API ang create Dialog
   * @param url
   * @param params
   * @param text
   */
  sendDataAndCreateDialog(url: string, params: any, text: string) {
    this.http.post(url, params).subscribe((res: HttpResponse<any>) => {
      let createDialog = this.dialog.open(DialogRoadLaneComponent, <MatDialogConfig>{
        data: {
          act: '',
          text: text,
          icon_class: "dialog-icon-success"
        }
      });
      createDialog.afterClosed().subscribe(async () => {
        this.disableButton = false;
        this.dialog.closeAll();
        await this.getLaneDataByDefault();
      });
    }, (error) => {
      const errorMessage = error.status == 409 || error.status == 422 ? `${this.error_data}  ${this.nameExisted}` : this.error_data;
      if (error.status !== 401 || error.status !== 403 || this.Globals.error || error.status == 409) {
        this.Globals.error = false;
        let errorDialog = this.dialog.open(DialogRoadLaneComponent, <MatDialogConfig>{
          data: {
            act: 'error',
            text: errorMessage,
            icon_class: 'dialog-icon-warning'
          }
        });
        errorDialog.afterClosed().subscribe(async () => {
          this.disableButton = false;
          this.dialog.closeAll();
        });
      }
    })
  }

  /**
   * Get selected sensor lane types from sensors_params.sensor_lane_types
   * @param sensorId
   */
  public async getSelectedSensorLaneTypes(sensorId: string) {
    let params: HttpParams = new HttpParams();
    params = params.set('sensor_id', sensorId);
    try {
      let res = await this.http.get('/api/sensors-params/get-sensor-lane-types', {params}).toPromise();
      return res.body;
    } catch (e) {
      console.log(e)
    }
  }

  /**
   * Get lane types from dict.sensor_lane_types
   */
  async getLaneTypesByDefault() {
    try {
      const url = '/api/dict/get-sensor-lane-types';
      const res = await this.http.get(url).toPromise();
      return res.body;
    } catch (e) {
      console.log(e);
    }
  }

  /**
   * Check if user isn't super admin show no access dialog.
   * @param data
   */
  checkAccess(data: any) {
    if (data.is_system) {
      if (this.Globals.user.role.name != 'Superadmin') {
        this.dialog.open(CreateDialogComponent, <MatDialogConfig>{
          data: {
            act: '',
            text: this.no_permission,
            icon_class: 'dialog-icon-warning'
          }
        });
      }
    }
  }

  /**
   * If lane is_system show edit/delete buttons only for super admin.
   * @param data
   */
  isSystem(data: any) {
    return data.is_system ? this.Globals.user.role.name == 'Superadmin' : !data.is_system;
  }

  async getSensorLaneIndexes(sensorId: string) {
    if (sensorId) {
      let params: HttpParams = new HttpParams();
      params = params.set('sensor_id', sensorId);
      try {
        let res = await this.http.get('/api/sensors-params/get-sensor-lanes', {params}).toPromise();
        return res.body;
      } catch (e) {
        console.log(e)
      }
    }
  }

  /**
   * Get all road lane types codes
   */
  public async fetchAllLaneTypesCodes() {
    try {
      let res = await this.http.get('/api/lanes/all-lane-types/codes').toPromise();
      return res.body;
    } catch (e) {
      console.log(e)
    }
  }

  selectLaneType(e: any) {
    this.laneTypeSel = e;
  }


  ngOnDestroy() {
    if (Boolean(this.changeLangCancel))
      this.changeLangCancel.unsubscribe();
  }
}
